import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { ItemOption } from '@models/item';
import { OrderOption } from '@models/order';
import useCalculatedOrder from '@store/item/hooks/useCalculatedOrder';
import useOptionControl from '@store/item/hooks/useOptionControl';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import SelectedOptionRow from './SelectedOptionRow';

interface Props {
    itemId: string;
}

/**
 * 선택된 퍼스널 옵션 목록
 * @param itemId
 * @constructor
 */
function SelectedPersonalOptionList({ itemId }:Props) {
    const { t } = useTranslation('item');
    const { resetPersonalOptions } = useOptionControl({ itemId });
    const { orderLines } = useCalculatedOrder();
    const optionsWithGroups = orderLines
        .map((line) => line.personalOptions).flat()
        .filter((og) => og.options.length !== 0); // 선택된 옵션만 표시

    if (optionsWithGroups.length === 0) {
        return (<Spacer/>);
    }
    return (
        <Container spacing={16} fullWidth >
            <Row justify='flex-end'
                fullWidth >
                <ResetText color={colors.primary}
                    onClick={resetPersonalOptions} >
                    {t('option.resetAll')}
                </ResetText>
            </Row>
            {optionsWithGroups.map((optionGroup) => {
                const { options, optionGroupId } = optionGroup;
                return (
                    <Fragment key={optionGroupId}>
                        {options.map((option) => {
                            const itemOption = toItemOption(option);
                            return (
                                <SelectedOptionRow orderOption={option}
                                    itemOption={itemOption}
                                    optionGroupId={optionGroupId}
                                    itemId={itemId}
                                    key={`${option.shopOptionId} ${optionGroupId}`} />
                            );
                        })}
                    </Fragment>
                );
            })}
        </Container>
    );
}

const Container = styled(Column)`
    padding: 20px 20px 16px; 
`;

const ResetText = styled(Text)`
    text-decoration: underline;
    text-underline-offset: 2px;
`;

const Spacer = styled.div`
    height: 14px;
`;

function toItemOption(option: OrderOption): ItemOption {
    return {
        optionId: option.shopOptionId,
        name: option.optionName,
        basePrice: option.optionPrice,
        salePrice: option.optionPrice,
        isDefault: false,
        isChangeable: true,
        imageUrls: [],
        maxQuantity: option.maxQuantity,
        posId: option.posId,
    };
}

export default SelectedPersonalOptionList;
